var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon122, _polygon123, _polygon124, _polygon125, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetroCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 980 1491.4",
    style: {
      enableBackground: "new 0 0 980 1491.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#101E42;}\r\n\t.st1{fill:#1B3066;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:#00F1FC;}\r\n\t.st5{fill:#6427C4;}\r\n\t.st6{fill:#E336D3;}\r\n\t.st7{fill:#33FFE6;}\r\n\t.st8{fill:#FCCF12;}\r\n\t.st9{fill:#F09002;}\r\n\t.st10{enable-background:new    ;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cards") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,3h846c66.3,0,120,53.7,120,120v1357.4l0,0H127c-66.3,0-120-53.7-120-120l0,0V3L7,3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1246.5 248.2,1246.2 490,1246 731.8,1246.2 852.7,1246.3 973.6,1246.5 852.7,1246.8 731.8,1246.8  490,1247 248.2,1246.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1258.8 248.2,1258.5 490,1258.3 731.8,1258.5 852.7,1258.6 973.6,1258.8 852.7,1259.1  731.8,1259.2 490,1259.3 248.2,1259.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1271.1 248.2,1270.8 490,1270.6 731.8,1270.8 852.7,1270.9 973.6,1271.1 852.7,1271.4  731.8,1271.5 490,1271.6 248.2,1271.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1283.4 248.2,1283.1 490,1282.9 731.8,1283.1 852.7,1283.2 973.6,1283.4 852.7,1283.7  731.8,1283.8 490,1283.9 248.2,1283.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1295.8 248.2,1295.4 490,1295.3 731.8,1295.4 852.7,1295.5 973.6,1295.8 852.7,1296 731.8,1296.1  490,1296.3 248.2,1296.1  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1308.1 248.2,1307.7 490,1307.6 731.8,1307.7 852.7,1307.8 973.6,1308.1 852.7,1308.3  731.8,1308.4 490,1308.6 248.2,1308.4  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1320.4 248.2,1320.1 490,1319.9 731.8,1320.1 852.7,1320.1 973.6,1320.4 852.7,1320.6  731.8,1320.7 490,1320.9 248.2,1320.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1332.7 248.2,1332.4 490,1332.2 731.8,1332.4 852.7,1332.4 973.6,1332.7 852.7,1332.9 731.8,1333  490,1333.2 248.2,1333  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1345 248.2,1344.7 490,1344.5 731.8,1344.7 852.7,1344.8 973.6,1345 852.7,1345.3 731.8,1345.3  490,1345.5 248.2,1345.3  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1357.3 248.2,1357 490,1356.8 731.8,1357 852.7,1357.1 973.6,1357.3 852.7,1357.6 731.8,1357.7  490,1357.8 248.2,1357.7  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1369.6 248.2,1369.3 490,1369.1 731.8,1369.3 852.7,1369.4 973.6,1369.6 852.7,1369.9 731.8,1370  490,1370.1 248.2,1370  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1381.9 248.2,1381.6 490,1381.4 731.8,1381.6 852.7,1381.7 973.6,1381.9 852.7,1382.2  731.8,1382.3 490,1382.4 248.2,1382.3  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1394.3 248.2,1393.9 490,1393.8 731.8,1393.9 852.7,1394 973.6,1394.3 852.7,1394.5 731.8,1394.6  490,1394.8 248.2,1394.6  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.4,1418.9 140.4,1418.6 259.5,1418.6 497.5,1418.4 735.6,1418.6 854.6,1418.6 973.6,1418.9  854.6,1419.1 735.6,1419.2 497.5,1419.4 259.5,1419.2 140.4,1419.1  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.4,1443.5 157.1,1443.3 273.7,1443.2 507,1443 740.3,1443.2 857,1443.3 973.6,1443.5 857,1443.8  740.3,1443.8 507,1444 273.7,1443.8 157.1,1443.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.4,1406.6 136.1,1406.3 255.7,1406.2 495,1406.1 734.3,1406.2 854,1406.3 973.6,1406.6 854,1406.8  734.3,1406.9 495,1407.1 255.7,1406.9 136.1,1406.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "30.4,1431.2 148.3,1430.9 266.2,1430.9 502,1430.7 737.8,1430.9 855.7,1430.9 973.6,1431.2  855.7,1431.4 737.8,1431.5 502,1431.7 266.2,1431.5 148.3,1431.4  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.4,1455.8 168.4,1455.6 283.5,1455.5 513.5,1455.3 743.6,1455.5 858.6,1455.6 973.6,1455.8  858.6,1456.1 743.6,1456.2 513.5,1456.3 283.5,1456.2 168.4,1456.1  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "74.4,1468.1 186.8,1467.9 299.2,1467.8 524,1467.6 748.8,1467.8 861.2,1467.9 973.6,1468.1  861.2,1468.4 748.8,1468.5 524,1468.6 299.2,1468.5 186.8,1468.4  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.4,1480.4 207.8,1480.2 317.2,1480.1 536,1479.9 754.8,1480.1 864.2,1480.2 973.6,1480.4  864.2,1480.7 754.8,1480.8 536,1480.9 317.2,1480.8 207.8,1480.7  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,914.1 248.2,913.8 490,913.6 731.8,913.8 852.7,913.8 973.6,914.1 852.7,914.3 731.8,914.4  490,914.6 248.2,914.4  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,951 248.2,950.7 490,950.5 731.8,950.7 852.7,950.8 973.6,951 852.7,951.3 731.8,951.4 490,951.5  248.2,951.4  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,963.3 248.2,963 490,962.8 731.8,963 852.7,963.1 973.6,963.3 852.7,963.6 731.8,963.7 490,963.8  248.2,963.7  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,988 248.2,987.6 490,987.5 731.8,987.6 852.7,987.7 973.6,988 852.7,988.2 731.8,988.3 490,988.5  248.2,988.3  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1012.6 248.2,1012.3 490,1012.1 731.8,1012.3 852.7,1012.3 973.6,1012.6 852.7,1012.8  731.8,1012.9 490,1013.1 248.2,1012.9  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1049.5 248.2,1049.2 490,1049 731.8,1049.2 852.7,1049.3 973.6,1049.5 852.7,1049.8 731.8,1049.8  490,1050 248.2,1049.8  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1061.8 248.2,1061.5 490,1061.3 731.8,1061.5 852.7,1061.6 973.6,1061.8 852.7,1062.1  731.8,1062.2 490,1062.3 248.2,1062.2  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1086.5 248.2,1086.1 490,1086 731.8,1086.1 852.7,1086.2 973.6,1086.5 852.7,1086.7 731.8,1086.8  490,1087 248.2,1086.8  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1111.1 248.2,1110.8 490,1110.6 731.8,1110.8 852.7,1110.8 973.6,1111.1 852.7,1111.3  731.8,1111.4 490,1111.6 248.2,1111.4  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1135.7 248.2,1135.4 490,1135.2 731.8,1135.4 852.7,1135.5 973.6,1135.7 852.7,1135.9 731.8,1136  490,1136.2 248.2,1136  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1160.3 248.2,1160 490,1159.8 731.8,1160 852.7,1160.1 973.6,1160.3 852.7,1160.6 731.8,1160.7  490,1160.8 248.2,1160.7  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1184.9 248.2,1184.6 490,1184.5 731.8,1184.6 852.7,1184.7 973.6,1184.9 852.7,1185.2  731.8,1185.3 490,1185.4 248.2,1185.3  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1197.3 248.2,1196.9 490,1196.8 731.8,1196.9 852.7,1197 973.6,1197.3 852.7,1197.5 731.8,1197.6  490,1197.8 248.2,1197.6  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1209.6 248.2,1209.3 490,1209.1 731.8,1209.3 852.7,1209.3 973.6,1209.6 852.7,1209.8  731.8,1209.9 490,1210.1 248.2,1209.9  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1221.9 248.2,1221.6 490,1221.4 731.8,1221.6 852.7,1221.7 973.6,1221.9 852.7,1222.1  731.8,1222.2 490,1222.4 248.2,1222.2  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1234.2 248.2,1233.9 490,1233.7 731.8,1233.9 852.7,1234 973.6,1234.2 852.7,1234.4 731.8,1234.5  490,1234.7 248.2,1234.5  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,520.1 248.2,519.8 490,519.6 731.8,519.8 852.7,519.9 973.6,520.1 852.7,520.3 731.8,520.4  490,520.6 248.2,520.4  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,557 248.2,556.7 490,556.5 731.8,556.7 852.7,556.8 973.6,557 852.7,557.3 731.8,557.4 490,557.5  248.2,557.4  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,569.3 248.2,569 490,568.8 731.8,569 852.7,569.1 973.6,569.3 852.7,569.6 731.8,569.7 490,569.8  248.2,569.7  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,594 248.2,593.7 490,593.5 731.8,593.6 852.7,593.7 973.6,594 852.7,594.2 731.8,594.3 490,594.5  248.2,594.3  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,618.6 248.2,618.3 490,618.1 731.8,618.3 852.7,618.4 973.6,618.6 852.7,618.8 731.8,618.9  490,619.1 248.2,618.9  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,655.5 248.2,655.2 490,655 731.8,655.2 852.7,655.3 973.6,655.5 852.7,655.8 731.8,655.9 490,656  248.2,655.9  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,667.8 248.2,667.5 490,667.3 731.8,667.5 852.7,667.6 973.6,667.8 852.7,668.1 731.8,668.2  490,668.3 248.2,668.2  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,692.5 248.2,692.1 490,692 731.8,692.1 852.7,692.2 973.6,692.5 852.7,692.7 731.8,692.8 490,693  248.2,692.8  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,704.8 248.2,704.5 490,704.3 731.8,704.5 852.7,704.5 973.6,704.8 852.7,705 731.8,705.1  490,705.3 248.2,705.1  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,717.1 248.2,716.8 490,716.6 731.8,716.8 852.7,716.8 973.6,717.1 852.7,717.3 731.8,717.4  490,717.6 248.2,717.4  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,741.7 248.2,741.4 490,741.2 731.8,741.4 852.7,741.5 973.6,741.7 852.7,742 731.8,742 490,742.2  248.2,742  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,766.3 248.2,766 490,765.8 731.8,766 852.7,766.1 973.6,766.3 852.7,766.6 731.8,766.7 490,766.8  248.2,766.7  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,791 248.2,790.6 490,790.5 731.8,790.6 852.7,790.7 973.6,791 852.7,791.2 731.8,791.3 490,791.5  248.2,791.3  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,815.6 248.2,815.3 490,815.1 731.8,815.3 852.7,815.3 973.6,815.6 852.7,815.8 731.8,815.9  490,816.1 248.2,815.9  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,840.2 248.2,839.9 490,839.7 731.8,839.9 852.7,840 973.6,840.2 852.7,840.5 731.8,840.5  490,840.7 248.2,840.5  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,864.8 248.2,864.5 490,864.3 731.8,864.5 852.7,864.6 973.6,864.8 852.7,865.1 731.8,865.2  490,865.3 248.2,865.2  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1098.8 248.2,1098.4 490,1098.3 731.8,1098.4 852.7,1098.5 973.6,1098.8 852.7,1099 731.8,1099.1  490,1099.3 248.2,1099.1  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1123.4 248.2,1123.1 490,1122.9 731.8,1123.1 852.7,1123.2 973.6,1123.4 852.7,1123.6  731.8,1123.7 490,1123.9 248.2,1123.7  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1148 248.2,1147.7 490,1147.5 731.8,1147.7 852.7,1147.8 973.6,1148 852.7,1148.3 731.8,1148.3  490,1148.5 248.2,1148.3  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1172.6 248.2,1172.3 490,1172.1 731.8,1172.3 852.7,1172.4 973.6,1172.6 852.7,1172.9 731.8,1173  490,1173.1 248.2,1173  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,729.4 248.2,729.1 490,728.9 731.8,729.1 852.7,729.2 973.6,729.4 852.7,729.7 731.8,729.7  490,729.9 248.2,729.7  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,754 248.2,753.7 490,753.5 731.8,753.7 852.7,753.8 973.6,754 852.7,754.3 731.8,754.4 490,754.5  248.2,754.4  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,778.7 248.2,778.3 490,778.2 731.8,778.3 852.7,778.4 973.6,778.7 852.7,778.9 731.8,779  490,779.2 248.2,779  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,803.3 248.2,803 490,802.8 731.8,803 852.7,803 973.6,803.3 852.7,803.5 731.8,803.6 490,803.8  248.2,803.6  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,827.9 248.2,827.6 490,827.4 731.8,827.6 852.7,827.7 973.6,827.9 852.7,828.2 731.8,828.2  490,828.4 248.2,828.2  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,852.5 248.2,852.2 490,852 731.8,852.2 852.7,852.3 973.6,852.5 852.7,852.8 731.8,852.9 490,853  248.2,852.9  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,877.2 248.2,876.8 490,876.7 731.8,876.8 852.7,876.9 973.6,877.2 852.7,877.4 731.8,877.5  490,877.7 248.2,877.5  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,889.5 248.2,889.1 490,889 731.8,889.1 852.7,889.2 973.6,889.5 852.7,889.7 731.8,889.8 490,890  248.2,889.8  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,901.8 248.2,901.5 490,901.3 731.8,901.5 852.7,901.5 973.6,901.8 852.7,902 731.8,902.1  490,902.3 248.2,902.1  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,926.4 248.2,926.1 490,925.9 731.8,926.1 852.7,926.2 973.6,926.4 852.7,926.7 731.8,926.7  490,926.9 248.2,926.7  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,938.7 248.2,938.4 490,938.2 731.8,938.4 852.7,938.5 973.6,938.7 852.7,939 731.8,939 490,939.2  248.2,939  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,975.7 248.2,975.3 490,975.2 731.8,975.3 852.7,975.4 973.6,975.7 852.7,975.9 731.8,976  490,976.2 248.2,976  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1000.3 248.2,999.9 490,999.8 731.8,999.9 852.7,1000 973.6,1000.3 852.7,1000.5 731.8,1000.6  490,1000.8 248.2,1000.6  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1024.9 248.2,1024.6 490,1024.4 731.8,1024.6 852.7,1024.7 973.6,1024.9 852.7,1025.1  731.8,1025.2 490,1025.4 248.2,1025.2  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1037.2 248.2,1036.9 490,1036.7 731.8,1036.9 852.7,1037 973.6,1037.2 852.7,1037.4 731.8,1037.5  490,1037.7 248.2,1037.5  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1074.2 248.2,1073.8 490,1073.7 731.8,1073.8 852.7,1073.9 973.6,1074.2 852.7,1074.4  731.8,1074.5 490,1074.6 248.2,1074.5  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,532.4 248.2,532.1 490,531.9 731.8,532.1 852.7,532.2 973.6,532.4 852.7,532.7 731.8,532.8  490,532.9 248.2,532.8  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,544.7 248.2,544.4 490,544.2 731.8,544.4 852.7,544.5 973.6,544.7 852.7,545 731.8,545.1  490,545.2 248.2,545.1  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,581.7 248.2,581.3 490,581.2 731.8,581.3 852.7,581.4 973.6,581.7 852.7,581.9 731.8,582  490,582.2 248.2,582  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,606.3 248.2,606 490,605.8 731.8,606 852.7,606 973.6,606.3 852.7,606.5 731.8,606.6 490,606.8  248.2,606.6  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,630.9 248.2,630.6 490,630.4 731.8,630.6 852.7,630.7 973.6,630.9 852.7,631.2 731.8,631.3  490,631.4 248.2,631.2  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,643.2 248.2,642.9 490,642.7 731.8,642.9 852.7,643 973.6,643.2 852.7,643.5 731.8,643.6  490,643.7 248.2,643.6  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,680.2 248.2,679.8 490,679.7 731.8,679.8 852.7,679.9 973.6,680.2 852.7,680.4 731.8,680.5  490,680.7 248.2,680.5  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,323.1 248.2,322.8 490,322.6 731.8,322.8 852.7,322.9 973.6,323.1 852.7,323.4 731.8,323.4  490,323.6 248.2,323.4  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,335.4 248.2,335.1 490,334.9 731.8,335.1 852.7,335.2 973.6,335.4 852.7,335.7 731.8,335.8  490,335.9 248.2,335.8  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,347.7 248.2,347.4 490,347.2 731.8,347.4 852.7,347.5 973.6,347.7 852.7,348 731.8,348.1  490,348.2 248.2,348.1  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,360 248.2,359.7 490,359.5 731.8,359.7 852.7,359.8 973.6,360 852.7,360.3 731.8,360.4 490,360.5  248.2,360.4  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,372.4 248.2,372 490,371.9 731.8,372 852.7,372.1 973.6,372.4 852.7,372.6 731.8,372.7 490,372.9  248.2,372.7  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,384.7 248.2,384.3 490,384.2 731.8,384.3 852.7,384.4 973.6,384.7 852.7,384.9 731.8,385  490,385.2 248.2,385  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,397 248.2,396.6 490,396.5 731.8,396.6 852.7,396.7 973.6,397 852.7,397.2 731.8,397.3 490,397.5  248.2,397.3  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,409.3 248.2,409 490,408.8 731.8,409 852.7,409 973.6,409.3 852.7,409.5 731.8,409.6 490,409.8  248.2,409.6  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,421.6 248.2,421.3 490,421.1 731.8,421.3 852.7,421.4 973.6,421.6 852.7,421.9 731.8,421.9  490,422.1 248.2,421.9  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,433.9 248.2,433.6 490,433.4 731.8,433.6 852.7,433.7 973.6,433.9 852.7,434.2 731.8,434.3  490,434.4 248.2,434.3  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,446.2 248.2,445.9 490,445.7 731.8,445.9 852.7,446 973.6,446.2 852.7,446.5 731.8,446.6  490,446.7 248.2,446.6  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,458.5 248.2,458.2 490,458 731.8,458.2 852.7,458.3 973.6,458.5 852.7,458.8 731.8,458.9 490,459  248.2,458.9  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,470.9 248.2,470.5 490,470.4 731.8,470.5 852.7,470.6 973.6,470.9 852.7,471.1 731.8,471.2  490,471.4 248.2,471.2  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,483.2 248.2,482.8 490,482.7 731.8,482.8 852.7,482.9 973.6,483.2 852.7,483.4 731.8,483.5  490,483.7 248.2,483.5  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,495.5 248.2,495.1 490,495 731.8,495.1 852.7,495.2 973.6,495.5 852.7,495.7 731.8,495.8 490,496  248.2,495.8  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,507.8 248.2,507.5 490,507.3 731.8,507.5 852.7,507.5 973.6,507.8 852.7,508 731.8,508.1  490,508.3 248.2,508.1  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,261.5 248.2,261.2 490,261 731.8,261.2 852.7,261.3 973.6,261.5 852.7,261.8 731.8,261.9 490,262  248.2,261.9  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,273.9 248.2,273.5 490,273.4 731.8,273.5 852.7,273.6 973.6,273.9 852.7,274.1 731.8,274.2  490,274.4 248.2,274.2  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,286.2 248.2,285.9 490,285.7 731.8,285.8 852.7,285.9 973.6,286.2 852.7,286.4 731.8,286.5  490,286.7 248.2,286.5  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,298.5 248.2,298.2 490,298 731.8,298.2 852.7,298.2 973.6,298.5 852.7,298.7 731.8,298.8 490,299  248.2,298.8  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,310.8 248.2,310.5 490,310.3 731.8,310.5 852.7,310.6 973.6,310.8 852.7,311 731.8,311.1  490,311.3 248.2,311.1  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,64.6 125.4,64.3 244.5,64.2 482.5,64.1 720.6,64.2 839.6,64.3 958.6,64.6 839.6,64.8 720.6,64.9  482.5,65.1 244.5,64.9 125.4,64.8  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,76.9 126.1,76.6 245.7,76.5 485,76.4 724.3,76.5 844,76.6 963.6,76.9 844,77.1 724.3,77.2  485,77.4 245.7,77.2 126.1,77.1  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,89.2 246.7,88.8 487,88.7 727.3,88.8 847.5,88.9 967.6,89.2 847.5,89.4 727.3,89.5 487,89.7  246.7,89.5  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,101.5 248.2,101.2 490,101 731.8,101.2 852.7,101.3 973.6,101.5 852.7,101.7 731.8,101.8 490,102  248.2,101.8  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,113.8 248.2,113.5 490,113.3 731.8,113.5 852.7,113.6 973.6,113.8 852.7,114.1 731.8,114.1  490,114.3 248.2,114.1  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,126.1 248.2,125.8 490,125.6 731.8,125.8 852.7,125.9 973.6,126.1 852.7,126.4 731.8,126.4  490,126.6 248.2,126.4  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,15.3 118.9,15.1 231.5,15 456.5,14.8 681.6,15 794.1,15.1 906.6,15.3 794.1,15.6 681.6,15.6  456.5,15.8 231.5,15.6 118.9,15.6  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,3 114.9,2.8 223.5,2.7 440.5,2.5 657.6,2.7 766.1,2.8 874.6,3 766.1,3.2 657.6,3.3 440.5,3.5  223.5,3.3 114.9,3.2  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,27.6 121.3,27.4 236.2,27.3 466,27.1 695.8,27.3 810.7,27.4 925.6,27.6 810.7,27.9 695.8,28  466,28.1 236.2,28 121.3,27.9  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,39.9 123.1,39.7 239.7,39.6 473,39.4 706.3,39.6 823,39.7 939.6,39.9 823,40.2 706.3,40.3  473,40.4 239.7,40.3 123.1,40.2  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,52.3 124.4,52 242.5,51.9 478.5,51.8 714.6,51.9 832.6,52 950.6,52.3 832.6,52.5 714.6,52.6  478.5,52.8 242.5,52.6 124.4,52.5  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,138.4 248.2,138.1 490,137.9 731.8,138.1 852.7,138.2 973.6,138.4 852.7,138.7 731.8,138.8  490,138.9 248.2,138.8  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,150.7 248.2,150.4 490,150.3 731.8,150.4 852.7,150.5 973.6,150.7 852.7,151 731.8,151.1  490,151.2 248.2,151.1  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,163.1 248.2,162.7 490,162.6 731.8,162.7 852.7,162.8 973.6,163.1 852.7,163.3 731.8,163.4  490,163.6 248.2,163.4  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,175.4 248.2,175 490,174.9 731.8,175 852.7,175.1 973.6,175.4 852.7,175.6 731.8,175.7 490,175.9  248.2,175.7  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,187.7 248.2,187.4 490,187.2 731.8,187.4 852.7,187.4 973.6,187.7 852.7,187.9 731.8,188  490,188.2 248.2,188  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,200 248.2,199.7 490,199.5 731.8,199.7 852.7,199.8 973.6,200 852.7,200.2 731.8,200.3 490,200.5  248.2,200.3  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,212.3 248.2,212 490,211.8 731.8,212 852.7,212.1 973.6,212.3 852.7,212.6 731.8,212.6 490,212.8  248.2,212.6  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,224.6 248.2,224.3 490,224.1 731.8,224.3 852.7,224.4 973.6,224.6 852.7,224.9 731.8,224.9  490,225.1 248.2,224.9  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,236.9 248.2,236.6 490,236.4 731.8,236.6 852.7,236.7 973.6,236.9 852.7,237.2 731.8,237.3  490,237.4 248.2,237.3  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,249.2 248.2,248.9 490,248.7 731.8,248.9 852.7,249 973.6,249.2 852.7,249.5 731.8,249.6  490,249.7 248.2,249.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7225,
    y1: 398.9775,
    x2: 889.3174,
    y2: 1197.5825,
    gradientTransform: "matrix(1 0 0 -1 0 1492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A172FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#987AFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#808FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#58B1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#30D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#4ABDDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#729BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#8A86F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#937EFA"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 294.4,
    className: "st2",
    width: 798.6,
    height: 798.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -90.6645,
    y1: 165.6206,
    x2: 1070.6646,
    y2: 1326.9395,
    gradientTransform: "matrix(1 0 0 -1 0 1492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A172FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#987AFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#808FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#58B1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#30D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#4ABDDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#729BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#8A86F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#937EFA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M853,0H7C3.1,0,0,3.1,0,7v1357.4c0,70.1,56.9,127,127,127l0,0h846c3.9,0,7-3.1,7-7V127C980,56.9,923.1,0,853,0 z M966,1477.4H713.4c-1.5,0-3-0.6-4.1-1.6l-10.1-9.2c-4.4-4.1-10.2-6.3-16.2-6.3H297c-6,0-11.8,2.3-16.2,6.3l-10.1,9.2 c-1.1,1-2.6,1.6-4.1,1.6H127c-62.4,0-113-50.6-113-113V24.8h439.8c4,0,7.9-1,11.4-2.9l13.3-7.2c0.9-0.5,1.9-0.7,2.9-0.7H853 c62.4,0,113,50.6,113,113V1477.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M906.4,277.3v832.8H73.6V277.3H906.4 M908.4,275.3H71.6v836.8h836.8V275.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M908.4,1196.6H71.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h836.8c0.6,0,1,0.4,1,1S909,1196.6,908.4,1196.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M908.4,1354H71.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h836.8c0.6,0,1,0.4,1,1S909,1354,908.4,1354z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.2,1289.8l-4.8,4.8c-4.1,4.1-10.7,4.1-14.7,0l-20.3-20.3l1.6-1.6c3.1-3.1,8.2-3.2,11.3-0.1 c0,0,0,0,0.1,0.1l18.7,18.7l4.8-4.8l-18.7-18.7c-5.8-5.8-15.1-5.8-20.9,0l-6.4,6.4l25.1,25.1c6.7,6.7,17.6,6.7,24.3,0l4.8-4.8 c3.1-3.1,8.2-3.2,11.3-0.1c0,0,0,0,0.1,0.1l0.9,0.9l-12.1,12.1c-2.8,2.8-7.3,3.2-10.5,0.9c-3,0.6-6,0.8-9.1,0.7l3.2,3.2 c5.8,5.8,15.3,5.8,21.1,0l16.9-16.9l-5.7-5.7C166.3,1284,157,1284,151.2,1289.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.6,1258.8l4.8-4.8c4.1-4.1,10.7-4.1,14.7,0l20.3,20.3l-1.6,1.6c-3.1,3.1-8.2,3.2-11.3,0.1c0,0,0,0-0.1-0.1 l-18.7-18.7l-4.7,4.8l18.7,18.7c5.8,5.8,15.1,5.8,20.9,0l6.4-6.4l-25.1-25.1c-6.7-6.7-17.6-6.7-24.3,0l-4.8,4.8 c-3.1,3.1-8.2,3.1-11.4,0l-0.9-0.9l12.1-12.1c2.8-2.8,7.3-3.2,10.5-0.9c3-0.6,6-0.8,9.1-0.7l-3.2-3.2c-5.8-5.8-15.3-5.8-21.1,0 l-16.8,16.8l5.7,5.7C134.5,1264.6,143.8,1264.6,149.6,1258.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.1,1354H71.6c-0.6,0-1-0.4-1-1v-157.5c0-0.6,0.4-1,1-1h157.5c0.6,0,1,0.4,1,1V1353 C230.1,1353.6,229.7,1354,229.1,1354z M72.6,1352h155.5v-155.5H72.6V1352z"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.6,1353.1 94.4,1353.1 71.6,1330.3  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.1,1353.1 229.1,1330.3 206.4,1353.1  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.1,1195.6 206.4,1195.6 229.1,1218.3  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.6,1195.6 71.6,1218.3 94.4,1195.6  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retro-disco-skin"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 315.7,
    className: "st5",
    width: 756.1,
    height: 756.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 693.7,
    className: "st6",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.5,788.2c0-52.2,42.3-94.5,94.5-94.5v189C248.8,882.7,206.5,840.4,206.5,788.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.5,788.2c0-52.2-42.3-94.5-94.5-94.5v189C164.2,882.7,206.5,840.4,206.5,788.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 882.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M773.5,977.3c52.2,0,94.5-42.3,94.5-94.5l0,0H679C679,934.9,721.3,977.3,773.5,977.3 C773.5,977.3,773.5,977.3,773.5,977.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M773.5,977.3c52.2,0,94.5,42.3,94.5,94.5l0,0H679C679,1019.6,721.3,977.3,773.5,977.3 C773.5,977.3,773.5,977.3,773.5,977.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 882.7,
    className: "st8",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.5,977.3c0,52.2,42.3,94.5,94.5,94.5v-189C626.8,882.8,584.5,925.1,584.5,977.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.5,977.3c0,52.2-42.3,94.5-94.5,94.5c0,0,0,0,0,0v-189C542.2,882.8,584.5,925.1,584.5,977.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 693.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M395.5,788.2c52.2,0,94.5,42.3,94.5,94.5H301C301,830.5,343.3,788.2,395.5,788.2L395.5,788.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M395.5,788.2c52.2,0,94.5-42.3,94.5-94.5H301C301,745.9,343.3,788.2,395.5,788.2L395.5,788.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 693.7,
    className: "st9",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M773.5,788.2c0-52.2-42.3-94.5-94.5-94.5c0,0,0,0,0,0v189C731.2,882.7,773.5,840.4,773.5,788.2 C773.5,788.2,773.5,788.2,773.5,788.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M773.5,788.2c0-52.2,42.3-94.5,94.5-94.5v189C815.9,882.7,773.6,840.4,773.5,788.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 882.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5,977.3c0-52.2,42.3-94.5,94.5-94.5v189C248.8,1071.7,206.5,1029.4,206.5,977.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5,977.3c0-52.2-42.3-94.5-94.5-94.5v189C164.2,1071.7,206.5,1029.4,206.5,977.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 882.7,
    className: "st7",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.5,977.3c0,52.2-42.3,94.5-94.5,94.5l0,0v-189C353.2,882.8,395.5,925.1,395.5,977.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.5,977.3c0,52.2,42.3,94.5,94.5,94.5v-189C437.8,882.8,395.5,925.1,395.5,977.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 693.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.5,788.2c0-52.2-42.3-94.5-94.5-94.5c0,0,0,0,0,0v189C542.2,882.7,584.5,840.4,584.5,788.2 C584.5,788.2,584.5,788.2,584.5,788.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.5,788.2c0-52.2,42.3-94.5,94.5-94.5v189C626.8,882.7,584.5,840.4,584.5,788.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 315.7,
    className: "st6",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.5,410.2c0-52.2,42.3-94.5,94.5-94.5v189C248.8,504.7,206.5,462.4,206.5,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.5,410.2c0-52.2-42.3-94.5-94.5-94.5v189C164.2,504.7,206.5,462.4,206.5,410.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 504.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M773.5,599.2c0-52.2-42.3-94.5-94.5-94.5c0,0,0,0,0,0v189C731.2,693.7,773.5,651.4,773.5,599.2 C773.5,599.2,773.5,599.2,773.5,599.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M773.5,599.2c0-52.2,42.3-94.5,94.5-94.5v189C815.9,693.7,773.6,651.4,773.5,599.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 504.7,
    className: "st8",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.5,599.2c0,52.2,42.3,94.5,94.5,94.5v-189C626.8,504.7,584.5,547,584.5,599.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.5,599.2c0,52.2-42.3,94.5-94.5,94.5c0,0,0,0,0,0v-189C542.2,504.7,584.5,547,584.5,599.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 315.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M395.5,410.2c0,52.2-42.3,94.5-94.5,94.5l0,0v-189C353.2,315.7,395.5,358,395.5,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M395.5,410.2c0,52.2,42.3,94.5,94.5,94.5v-189C437.8,315.7,395.5,358,395.5,410.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 315.7,
    className: "st9",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M773.5,410.2c0-52.2-42.3-94.5-94.5-94.5c0,0,0,0,0,0v189C731.2,504.7,773.5,462.4,773.5,410.2 C773.5,410.2,773.5,410.2,773.5,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M773.5,410.2c0-52.2,42.3-94.5,94.5-94.5v189C815.9,504.7,773.5,462.4,773.5,410.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 504.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5,599.2c-52.2,0-94.5-42.3-94.5-94.5h189C301,556.9,258.7,599.2,206.5,599.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5,599.2c-52.2,0-94.5,42.3-94.5,94.5h189C301,641.5,258.7,599.2,206.5,599.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 504.7,
    className: "st7",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.5,599.2c0,52.2-42.3,94.5-94.5,94.5v-189C353.2,504.7,395.5,547,395.5,599.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.5,599.2c0,52.2,42.3,94.5,94.5,94.5v-189C437.8,504.7,395.5,547,395.5,599.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 315.7,
    className: "st5",
    width: 189,
    height: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.5,410.2c-52.2,0-94.5,42.3-94.5,94.5c0,0,0,0,0,0h189C679,452.5,636.7,410.2,584.5,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.5,410.2c-52.2,0-94.5-42.3-94.5-94.5l0,0h189C679,367.9,636.7,410.2,584.5,410.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M807.7,1265.2l-3.8,18h13.8v8h-15.5l-4.3,20h-8.7l4.3-20h-21l-4.3,20h-8.7l4.3-20h-15.7v-8h17.4l3.8-18h-15.5 v-8H771l4.3-20h8.7l-4.3,20h21l4.3-20h8.7l-4.3,20h13.9v8H807.7z M799,1265.2h-21l-3.8,18h21L799,1265.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M840.9,1242.3c4.4-3.9,10.4-5.8,17.9-5.8c5,0,9.3,0.9,12.8,2.6c3.6,1.7,6.3,4.1,8.1,7.1 c1.8,3,2.8,6.4,2.8,10.1c0,4.4-1.1,8-3.3,10.8c-2.2,2.8-4.8,4.7-7.7,5.7v0.4c3.8,1.3,6.8,3.4,9,6.3c2.2,2.9,3.3,6.7,3.3,11.3 c0,4.1-1,7.8-2.9,11c-1.9,3.2-4.7,5.6-8.3,7.5c-3.6,1.8-8,2.7-13,2.7c-8,0-14.4-2-19.1-5.9c-4.8-3.9-7.3-9.9-7.5-17.8h16.6 c0.1,2.9,0.9,5.3,2.5,6.9c1.6,1.7,3.9,2.6,7,2.6c2.6,0,4.6-0.8,6-2.3c1.4-1.5,2.2-3.5,2.2-6c0-3.2-1-5.5-3-7 c-2-1.4-5.3-2.2-9.8-2.2h-3.2v-13.9h3.2c3.4,0,6.1-0.6,8.3-1.8c2.1-1.2,3.1-3.3,3.1-6.3c0-2.4-0.7-4.3-2-5.6c-1.3-1.3-3.2-2-5.5-2 c-2.5,0-4.4,0.8-5.6,2.3c-1.2,1.5-2,3.4-2.2,5.7h-16.7C834.2,1251.6,836.5,1246.1,840.9,1242.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.1,180.2l-10.6-19.8h-1.6v19.8H95v-53.6h23.5c4.3,0,8,0.7,10.9,2.2c3,1.5,5.2,3.5,6.8,6.2 c1.5,2.6,2.3,5.5,2.3,8.8c0,3.6-1,6.9-3,9.6c-2,2.8-4.9,4.7-8.8,5.9l12.1,20.9H122.1z M109.9,150.2h7.4c2,0,3.5-0.5,4.6-1.4 c1-1,1.5-2.4,1.5-4.2c0-1.7-0.5-3.1-1.6-4.1c-1-1-2.5-1.5-4.5-1.5h-7.4V150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161.6,138.5v8.7h17.1v11.3h-17.1v9.7H181v11.9h-34.3v-53.6H181v11.9H161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.3,126.6v11.9H216v41.7h-14.9v-41.7h-14.1v-11.9H230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.5,180.2l-10.6-19.8h-1.6v19.8h-14.9v-53.6h23.5c4.3,0,8,0.7,10.9,2.2c3,1.5,5.2,3.5,6.8,6.2 c1.5,2.6,2.3,5.5,2.3,8.8c0,3.6-1,6.9-3,9.6c-2,2.8-4.9,4.7-8.8,5.9l12.1,20.9H264.5z M252.2,150.2h7.4c2,0,3.5-0.5,4.6-1.4 c1-1,1.5-2.4,1.5-4.2c0-1.7-0.5-3.1-1.6-4.1c-1-1-2.5-1.5-4.5-1.5h-7.4V150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.9,177.2c-4.2-2.4-7.5-5.6-10-9.8c-2.5-4.2-3.7-8.9-3.7-14.2c0-5.3,1.2-10,3.7-14.2 c2.5-4.2,5.8-7.4,10-9.8c4.2-2.3,8.8-3.5,13.8-3.5c5.1,0,9.7,1.2,13.9,3.5c4.2,2.3,7.5,5.6,9.9,9.8c2.4,4.2,3.6,8.9,3.6,14.2 c0,5.3-1.2,10-3.6,14.2c-2.4,4.2-5.8,7.4-10,9.8c-4.2,2.4-8.8,3.5-13.8,3.5C309.8,180.7,305.1,179.5,300.9,177.2z M323.8,163.1 c2.2-2.5,3.3-5.8,3.3-10c0-4.3-1.1-7.6-3.3-10.1c-2.2-2.5-5.2-3.7-9-3.7c-3.9,0-6.9,1.2-9,3.7c-2.2,2.5-3.3,5.8-3.3,10.1 c0,4.2,1.1,7.5,3.3,10c2.2,2.5,5.2,3.7,9,3.7C318.6,166.9,321.6,165.6,323.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M402.4,130c4.2,2.3,7.5,5.4,9.8,9.5c2.3,4.1,3.4,8.7,3.4,13.9c0,5.2-1.2,9.8-3.5,13.8 c-2.3,4.1-5.6,7.2-9.8,9.5c-4.2,2.3-9.1,3.5-14.7,3.5h-21.2v-53.6h21.2C393.3,126.6,398.2,127.7,402.4,130z M396.8,163.4 c2.5-2.4,3.7-5.8,3.7-10.1c0-4.4-1.2-7.8-3.7-10.2c-2.5-2.4-5.9-3.6-10.3-3.6h-5.2V167h5.2C390.9,167,394.3,165.8,396.8,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.7,126.6v53.6h-14.9v-53.6H438.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.6,176.2c-4-3-6.2-7.2-6.5-12.7H463c0.2,1.9,0.7,3.2,1.7,4.1c1,0.9,2.2,1.3,3.7,1.3c1.4,0,2.5-0.3,3.4-1 c0.9-0.7,1.3-1.6,1.3-2.8c0-1.6-0.7-2.8-2.2-3.6c-1.5-0.9-3.9-1.8-7.1-2.9c-3.5-1.2-6.3-2.3-8.5-3.4c-2.2-1.1-4-2.7-5.6-4.8 c-1.6-2.1-2.4-4.9-2.4-8.2c0-3.4,0.9-6.4,2.6-8.9c1.7-2.5,4.1-4.3,7.1-5.6s6.5-1.9,10.3-1.9c6.2,0,11.2,1.5,14.9,4.4 c3.7,2.9,5.7,7,6,12.3h-16.2c-0.1-1.6-0.5-2.8-1.5-3.6c-0.9-0.8-2.1-1.2-3.6-1.2c-1.1,0-2,0.3-2.7,1c-0.7,0.7-1.1,1.6-1.1,2.8 c0,1,0.4,1.9,1.2,2.6c0.8,0.7,1.8,1.4,2.9,1.9c1.2,0.5,2.9,1.2,5.2,2c3.4,1.2,6.2,2.3,8.4,3.5c2.2,1.1,4.1,2.7,5.7,4.8 c1.6,2.1,2.4,4.6,2.4,7.8c0,3.2-0.8,6.1-2.4,8.6c-1.6,2.5-3.9,4.5-6.9,6c-3,1.5-6.6,2.2-10.7,2.2 C462.7,180.7,457.6,179.2,453.6,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M498.9,139.2c2.2-4.1,5.3-7.3,9.4-9.7c4.1-2.3,8.7-3.5,14-3.5c6.7,0,12.3,1.8,16.9,5.4 c4.6,3.6,7.5,8.4,8.8,14.6h-16c-1-2-2.3-3.6-4-4.6c-1.7-1.1-3.7-1.6-5.9-1.6c-3.4,0-6.2,1.2-8.2,3.7c-2.1,2.5-3.1,5.7-3.1,9.8 c0,4.2,1,7.5,3.1,9.9c2.1,2.5,4.8,3.7,8.2,3.7c2.2,0,4.2-0.5,5.9-1.6c1.7-1.1,3-2.6,4-4.6h16c-1.3,6.1-4.3,11-8.8,14.6 c-4.6,3.6-10.2,5.4-16.9,5.4c-5.3,0-9.9-1.2-14-3.5c-4.1-2.3-7.2-5.5-9.4-9.7c-2.2-4.1-3.3-8.9-3.3-14.2 C495.6,148,496.7,143.3,498.9,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M568.4,177.2c-4.2-2.4-7.5-5.6-10-9.8c-2.5-4.2-3.7-8.9-3.7-14.2c0-5.3,1.2-10,3.7-14.2 c2.5-4.2,5.8-7.4,10-9.8c4.2-2.3,8.8-3.5,13.8-3.5c5.1,0,9.7,1.2,13.9,3.5c4.2,2.3,7.5,5.6,9.9,9.8c2.4,4.2,3.6,8.9,3.6,14.2 c0,5.3-1.2,10-3.6,14.2c-2.4,4.2-5.8,7.4-10,9.8c-4.2,2.4-8.8,3.5-13.8,3.5C577.2,180.7,572.6,179.5,568.4,177.2z M591.2,163.1 c2.2-2.5,3.3-5.8,3.3-10c0-4.3-1.1-7.6-3.3-10.1c-2.2-2.5-5.2-3.7-9-3.7c-3.9,0-6.9,1.2-9,3.7c-2.2,2.5-3.3,5.8-3.3,10.1 c0,4.2,1.1,7.5,3.3,10c2.2,2.5,5.2,3.7,9,3.7C586,166.9,589,165.6,591.2,163.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroCard);
export default __webpack_public_path__ + "static/media/Retro_card.d67b1b921f40326017b48dd85eeb31c6.svg";
export { ForwardRef as ReactComponent };